export class OnboardingTipsConstant {
  public static PROFILE = {
    title: $localize`:@@tips.profile_2fa:Turn on 2FA`,
    desc: $localize`:@@tips.profile_2fa_desc: An additional layer of security for your account. Ensures the safety of your personal data. With 2FA, a potential compromise of your credentials won’t unlock the account.`,
    buttons: 'basic',
  };

  public static DASHBOARD = {
    title: $localize`:@@common.dashboard:Dashboard`,
    desc: $localize`:@@tips.dashboard_desc:Dashboard displays statistics which shows system work's efficiency.  It's truly irreplaceable in situations of time saving and having a finger on the pulse.`,
    buttons: 'basic',
  };

  public static OFFERS = {
    title: $localize`:@@common.offers:Offers`,
    desc: $localize`:@@tips.offers_desc:Welcome to the Offers section, here you can see the list of offers available.
     You can click the <b>View Offer</b> button for more detailed information, review additional marketing tools, and set up tracking links.`,
    buttons: 'basic',
  };

  public static OFFER = {
    title: $localize`:@@common.offer:Offer`,
    desc: $localize`:@@tips.offer_desc:To promote the offer, select the <b>Tracking Link</b> tab to get the link and place it on your resource. Now you have everything you need to start generating traffic!`,
    buttons: 'basic',
  };

  public static CLICKS = {
    title: $localize`:@@common.clicks:Clicks`,
    desc: $localize`:@@tips.clicks_desc:All click events are recorded in this table along with information about leads. Use any attribute in the table as a filter to find only specific clicks.`,
    tips: [
      $localize`:@@tips.clicks_tips:Each click has a unique ID assigned to it. You can see a more detailed page dedicated to that click by clicking its ID button. It also includes aff_sub information and the list of related conversions`,
    ],
    buttons: 'dots',
  };

  public static DRILLDOWN = {
    title: $localize`:@@common.drilldown:Drilldown`,
    desc: $localize`:@@tips.drilldown_desc:Drilldown Report represents a multilevel report, where you can simultaneously examine aggregated data on top levels and granular data on bottom levels. Let's walk through its main features.`,
    tips: [
      $localize`:@@tips.drilldown_tips:Groups define the subject of the report. For example, with the <b>Affiliate</b> group, data will be gathered on each affiliate in a separate row.`,
      $localize`:@@tips.drilldown_tips_gear_button:Manage metrics used in the report. Each added metric creates a new column in the report.`,
      $localize`:@@tips.drilldown_tips_conditions:Conditions allow you to set specific limitations to the data in the report.`,
    ],
    buttons: 'dots',
    tipNames: ['group', 'metrics', 'conditions'],
  };

  public static CONVERSIONS = {
    title: $localize`:@@common.conversions:Conversions`,
    desc: $localize`:@@tips.conversions_desc:Conversion is recorded in this table each time a lead performs a target action. The Goal of an Offer defines the target action. It can be a deposit, registration, or purchase.`,
    buttons: 'basic',
  };

  public static INVOICES = {
    title: $localize`:@@common.invoices:Invoices`,
    desc: $localize`:@@tips.invoices_desc:Create a new invoice to request a payment. You can create and edit invoices only in the Draft status. Admins will update their status after review. Click the PDF icon to download.`,
    buttons: 'basic',
  };

  public static AFFILIATETRACKERS = {
    title: $localize`:@@common.affiliate_trackers:Affiliate Trackers`,
    desc: $localize`:@@tips.affiliate_trackers_desc:Allows you to add a third-party tracking link to monitor your performance (it can be either a postback or the iFrame pixel). To enable it, admins must approve your tracking link.`,
    buttons: 'basic',
  };

  public static REPORTS = {
    title: $localize`:@@common.reports:Reports`,
    desc: $localize`:@@tips.reports_desc:Data Exporter tab presents the Data Exporter which is to generate a CSV with full and wide data for your needs.`,
    tips: [
      $localize`:@@tips.reports_tips1:When you’ve chosen the type of report, fill in the required settings, such as Range, Conditions, and Columns.`,

      $localize`:@@tips.reports_tips2:Range – specify the period. You can also see and apply such preset time frames as Today, Yesterday, This Week, Last Week, This Month, Last Month, and This Year.`,

      $localize`:@@tips.reports_tips3:Conditions – When one or several conditions are selected, only data that matches them will be collected. You can add more than one using the “+” button.`,

      $localize`:@@tips.reports_tips4:You can always use the “×” button to delete unnecessary conditions.`,

      $localize`:@@tips.reports_tips5:Columns – Here for you to include or exclude columns needed.`,

      $localize`:@@tips.reports_tips6:After you finish push the <b>View Report</b> button to check that the report contains everything you need.`,

      $localize`:@@tips.reports_tips7:Once checked, click the <b>Download CSV</b> button and the system will download a file with a report.`,
    ],
    buttons: 'dots',
  };

  public static SMARTLINKS = {
    title: $localize`:@@common.smart_links:Smart Links`,
    desc: $localize`:@@tips.smart_links_desc:Create a smart link which can forward traffic from several landing pages in different languages
    depending on the lead’s IP address to the suitable offers.`,
    tips: [
      $localize`:@@tips.smartlinks_tips1:Press <b>“Сreate”</b> button in order to add smart link.`,
      $localize`:@@tips.smartlinks_tips2:Press on the id button of smart link to see detailed information`,
    ],
    tipNames: ['create', 'id'],
    buttons: 'dots',
  };
  public static COMPARINGANALYTICS = {
    title: $localize`:@@common.comparing_analytics:Comparing Analytics`,
    desc: $localize`:@@tips.comparing_analytics_desc:This tool allows you to compare affiliates, advertisers, offers, countries, and other entities in two different periods by various metrics.`,
    tips: [
      $localize`:@@tips.comparing_analytics_tips1:For each metric, three columns will be displayed in the table: amount in the first period, amount in the second period, and the difference between them (net amount)`,
      $localize`:@@tips.comparing_analytics_tips2:Conditions allow you to set specific limitations to the data in the report.`,
    ],
    tipNames: ['metrics', 'conditions'],
    buttons: 'dots',
  };
}
